// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
function useImageHasRendered(debug) {
  var match = React.useState(function () {
    return false;
  });
  var setHasRendered = match[1];
  var hasRendered = match[0];
  var firstCheckRef = React.useRef(undefined);
  var secondCheckRef = React.useRef(undefined);
  var afterAllChecks = function (param) {
    if (debug) {
      console.log("Last check complete. Image has rendered", String(Date.now()));
    }
    Curry._1(setHasRendered, function (param) {
      return true;
    });
  };
  var nextCheck = function (param) {
    if (debug) {
      console.log("Doing second and last check...", String(Date.now()));
    }
    var requestId = requestAnimationFrame(afterAllChecks);
    secondCheckRef.current = Caml_option.some(requestId);
  };
  var startCheck = function (param) {
    if (debug) {
      console.log("Doing first check.. ", String(Date.now()));
    }
    var requestId = requestAnimationFrame(nextCheck);
    firstCheckRef.current = Caml_option.some(requestId);
  };
  React.useEffect(function () {
    if (hasRendered) {
      Belt_Option.forEach(firstCheckRef.current, function (prim) {
        cancelAnimationFrame(prim);
      });
      Belt_Option.forEach(secondCheckRef.current, function (prim) {
        cancelAnimationFrame(prim);
      });
    }
  }, [hasRendered]);
  React.useEffect(function () {
    return function (param) {
      Belt_Option.forEach(firstCheckRef.current, function (prim) {
        cancelAnimationFrame(prim);
      });
      Belt_Option.forEach(secondCheckRef.current, function (prim) {
        cancelAnimationFrame(prim);
      });
    };
  }, []);
  return [startCheck, hasRendered];
}
function $$Image(Props) {
  var src = Props.src;
  var width = Props.width;
  var height = Props.height;
  var alt = Props.alt;
  var draggable = Props.draggable;
  var style = Props.style;
  var fetchPriority = Props.fetchPriority;
  var loading = Props.loading;
  var dataTestId = Props.dataTestId;
  var dataId = Props.dataId;
  var dataOriginalSrc = Props.dataOriginalSrc;
  var dataFitRule = Props.dataFitRule;
  var crossOrigin = Props.crossOrigin;
  var onLoad = Props.onLoad;
  var onRender = Props.onRender;
  var onDragStart = Props.onDragStart;
  var match = useImageHasRendered(false);
  var isMainImageLoaded = match[1];
  var startCheckingImageHasRendered = match[0];
  React.useEffect(function () {
    if (onRender !== undefined) {
      Curry._1(startCheckingImageHasRendered, undefined);
    }
  }, []);
  React.useEffect(function () {
    if (isMainImageLoaded) {
      Belt_Option.forEach(onRender, function (onRender) {
        Curry._1(onRender, undefined);
      });
    }
  }, [isMainImageLoaded]);
  var tmp = {
    draggable: draggable,
    style: style,
    alt: alt,
    height: height,
    src: src,
    width: width,
    onDragStart: onDragStart,
    onLoad: onLoad
  };
  if (crossOrigin !== undefined) {
    tmp.crossOrigin = Caml_option.valFromOption(crossOrigin);
  }
  var tmp$1 = {
    children: React.createElement("img", tmp)
  };
  if (dataTestId !== undefined) {
    tmp$1.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp$1.dataId = dataId;
  }
  if (dataOriginalSrc !== undefined) {
    tmp$1.dataOriginalSrc = Caml_option.valFromOption(dataOriginalSrc);
  }
  if (dataFitRule !== undefined) {
    tmp$1.dataFitRule = Caml_option.valFromOption(dataFitRule);
  }
  if (fetchPriority !== undefined) {
    tmp$1.fetchPriority = Caml_option.valFromOption(fetchPriority);
  }
  if (loading !== undefined) {
    tmp$1.loading = Caml_option.valFromOption(loading);
  }
  return React.createElement(DataAttribute$Showside.make, tmp$1);
}
$$Image.displayName = "Image";
var make = $$Image;
export { useImageHasRendered, make };
/* react Not a pure module */